/* eslint-disable */
import * as Types from '../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUserInfoQueryVariables = Types.Exact<{
  email: Types.Scalars['String'];
}>;


export type GetUserInfoQuery = { __typename: 'Query', user: { __typename: 'User', id: string, email: string, first_name: string, last_name: string, is_active: boolean, is_external: boolean, country_code: string, region_id: string | null, label_id: string | null, space_id: string | null, unit_id: string | null, role: { __typename: 'UserRole', role_id: string, expire_at: string | null }, abilities: { __typename: 'Abilities', canCreateStory: boolean | null, canCreateCampaign: boolean | null, canViewAdminTab: boolean | null, canChangeCampaignUnit: boolean | null, canGlobalize: boolean | null }, assigned_campaigns: Array<{ __typename: 'Campaign', id: string | null, label_id: string | null }> | null }, spaces: Array<{ __typename: 'Space', id: string, name: string, labels: Array<{ __typename: 'Label', id: string }> }>, zones: Array<{ __typename: 'Label', id: string, name: string }> };


export const GetUserInfoDocument = gql`
    query getUserInfo($email: String!) {
  user: findUserByEmail(email: $email) {
    id
    email
    first_name
    last_name
    is_active
    is_external
    role {
      role_id
      expire_at
    }
    country_code
    region_id
    label_id
    space_id
    unit_id
    abilities {
      canCreateStory
      canCreateCampaign
      canViewAdminTab
      canChangeCampaignUnit
      canGlobalize
    }
    assigned_campaigns {
      id
      label_id
    }
  }
  spaces: getSpaces {
    id
    name
    labels {
      id
    }
  }
  zones: getLabels {
    id
    name
  }
}
    `;

/**
 * __useGetUserInfoQuery__
 *
 * To run a query within a React component, call `useGetUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInfoQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetUserInfoQuery(baseOptions: Apollo.QueryHookOptions<GetUserInfoQuery, GetUserInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserInfoQuery, GetUserInfoQueryVariables>(GetUserInfoDocument, options);
      }
export function useGetUserInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserInfoQuery, GetUserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserInfoQuery, GetUserInfoQueryVariables>(GetUserInfoDocument, options);
        }
export type GetUserInfoQueryHookResult = ReturnType<typeof useGetUserInfoQuery>;
export type GetUserInfoLazyQueryHookResult = ReturnType<typeof useGetUserInfoLazyQuery>;